import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import BackToTop from "../../components/back-to-top"
import { Container, Row, Col } from "reactstrap"
import { LazyLoadImage } from "react-lazy-load-image-component"

const Michael = () => {
  return (
    <Layout>
      <Seo title="Doctor Michael Bauer, DVM" />
      <div className="hero-adjustment pb-0">
        <div className="container">
          <div className="hero-content-wrapper">
            <div className="row no-gutters">
              <div className="col-12 col-md-7">
                <div className="hero-dog-bg">
                  <div className="dog-bg"></div>
                </div>
              </div>
              <div className="col-12 col-md-5">
                <div className="hero-video">
                  <div>
                    <div>
                      <div className="video-modal-btn no-video">
                        <LazyLoadImage
                          effect="blur"
                          src="/assets/img/tplo-video.jpg"
                          alt="video"
                          className="video-img img-fluid v-h"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-only-heading inner-page-title text-right arthroscopy-hero no-videoHero">
              <h1>
                Meet <br /> Dr. Michael <br /> Bauer
              </h1>
            </div>
          </div>
        </div>
      </div>
      <Container className="acl-container mb-5 mt-5 mt-md-0">
        <div className="doctor-body">
          <Row className="border-none">
            <Col md={4} className="img-resp">
              <LazyLoadImage
                effect="blur"
                src="/assets/img/bauer_2015.jpg"
                alt="Doctor"
                className="img-fluid mb-4"
              />
            </Col>
            <Col md={8}>
              <p>
                Dr. Michael Bauer is a native Kentuckian but has called Colorado
                home for the past 25 years. He received his Veterinary degree
                from Auburn University in 1982 and completed a surgical
                residency program at the University of Tennessee in 1986. He
                taught veterinary surgery for 10 years at the University of
                Saskatchewan, Purdue University and Colorado State University.
              </p>
              <p>
                In 1996 Dr. Bauer moved to Colorado Springs and started a small
                animal surgical practice that gradually evolved into Colorado
                Canine Orthopedics and Rehab. Dr. Bauer is passionate about
                helping animals and helping people that love their animals the
                way he loves his. He takes prides in treating people the way he
                would like to be treated if his pets were in need.
              </p>
              <p>
                His family includes his wonderful wife Kimberly, and his other
                four-legged family members: Izzy (mixed breed rescue and tennis
                ball expert) and Piggy (rescue kitty that has always loved to
                eat). Aside from spending time with his family, Dr. Bauer enjoys
                cycling, skiing, yoga, fly-fishing and playing guitar.
              </p>
            </Col>
          </Row>
        </div>
        <div className="doctor-video">
          <Row className="border-none">
            <Col md={12}>
              <div className="embed-container">
                <iframe
                  src="https://player.vimeo.com/video/445627889"
                  frameborder="0"
                  webkitAllowFullScreen
                  mozallowfullscreen
                  allowFullScreen
                  title="doctor"
                ></iframe>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <BackToTop />
      {/* </div> */}
    </Layout>
  )
}

export default Michael
